import React from 'react'

import DataHealthIncidentProcessTemplate from 'components_new/templates/internal/DataHealthIncidentProcess'
import { dataHealthTabPath } from 'components_new/templates/internal/DataHealth/lib'
import PageLayout from 'components_new/templates/PageLayout'

const DataHealthIncidentProcess = () => (
  <PageLayout
    content={{ disablePadding: true, fullWidth: true }}
    topbar={{
      breadcrumbs: [
        { title: 'Admin' },
        { href: dataHealthTabPath('overview'), title: 'Datahälsa' },
        { title: 'Incidentprocess' }
      ]
    }}
    variant="static"
  >
    <DataHealthIncidentProcessTemplate />
  </PageLayout>
)

export default DataHealthIncidentProcess
